import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-service-form-actions',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './service-form-actions.component.html',
  styleUrl: './service-form-actions.component.scss'
})
export class ServiceFormActionsComponent {
  @Output() exit: EventEmitter<void> = new EventEmitter<void>();
  @Output() saveDraft: EventEmitter<void> = new EventEmitter<void>();
  @Output() deleteDraft: EventEmitter<void> = new EventEmitter<void>();
  @Output() continue: EventEmitter<void> = new EventEmitter<void>();
  @Input() isFirstStep: boolean = false;
  @Input() isNew: boolean = false;
  @Input() isLastStep: boolean = false;
  @Input() showSaveDraft: boolean = true;
  @Input() isDone: boolean = false;
  @Input() isSubmitting: boolean = false;
  @Input() showSubmit: boolean = true;

  get isLoading(): boolean {
    return this.isSubmitting;
  }

  onSubmit() {
    this.continue.emit();
  }

  onDeleteDraft() {
    this.deleteDraft.emit();
  }
}
